var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titleTxt"},_vm._l((_vm.titleArr),function(item,index){return _c('span',[_c('span',[_vm._v(_vm._s(item))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index + 1 < _vm.titleArr.length),expression:"index + 1 < titleArr.length"}],staticClass:"position"},[_vm._v("/")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1e5f6a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subTitle/index.vue
// module id = 583
// module chunks = 65